import { cn } from '@/lib/utils';
import { RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import React from 'react';

type Props = {
  patients: {
    ID: string;
    fname: string;
    lname: string;
  }[];
  onChange: (patient: string) => void;
  value: string | null;
};

const SchedulePatients: React.FC<Props> = ({ patients, onChange, value }) => {
  const hasOne = patients?.length === 1;

  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      id="patients"
      defaultValue={hasOne && patients?.[0] ? `${patients[0].ID}` : 'no-preference'}
    >
      <RadioGroup.Label>
        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
          {hasOne ? '' : 'Who is this appointment for?'}
        </h3>
      </RadioGroup.Label>
      <div className="flex flex-col gap-2.5">
        {patients?.map(patient => (
          <RadioGroup.Option
            key={patient.ID}
            value={patient.ID}
            disabled={hasOne}
            className={({ checked, active }) =>
              cn(
                'portal-card relative flex cursor-pointer p-4 focus:outline-none transition-shadow',
                checked ? 'ring-2 ring-[var(--primary-color)]' : '',
                active ? 'ring-2 ring-[var(--primary-color)]' : ''
              )
            }
          >
            {({ checked }) => (
              <>
                <span className="flex flex-1">
                  <div className="flex gap-x-3 items-center">
                    <span
                      className="inline-flex h-10 w-10 items-center justify-center rounded-xl text-white font-bold text-sm"
                      style={{ backgroundColor: 'var(--primary-color)' }}
                    >
                      {patient.fname?.charAt(0)?.toUpperCase()}
                      {patient.lname?.charAt(0)?.toUpperCase()}
                    </span>
                    <div className="min-w-0 flex-auto text-left">
                      <RadioGroup.Label
                        as="span"
                        className="text-sm font-semibold text-gray-900 dark:text-gray-100"
                      >
                        {patient.fname} {patient.lname}
                      </RadioGroup.Label>
                    </div>
                  </div>
                </span>
                <CheckCircleIcon
                  className={cn(
                    hasOne || checked ? 'h-5 w-5 text-[var(--primary-color)]' : 'hidden'
                  )}
                  aria-hidden="true"
                />
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
};

export default SchedulePatients;
